export const LogoMark = ({ className = "h-12 w-12" }) => (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
        <circle cx="32" cy="32" r="29" fill="#F8F6F0" stroke="#2D4A3E" strokeWidth="2.5" />
        <circle cx="32" cy="32" r="25" fill="none" stroke="#8A6D1F" strokeWidth="0.8" opacity="0.6" />
        <circle cx="32" cy="9" r="2" fill="#8A6D1F" />
        <path d="M13 44c-4-6-4-13 0-19 4 6 4 13 0 19z" fill="#2D4A3E" />
        <path d="M51 44c4-6 4-13 0-19-4 6-4 13 0 19z" fill="#2D4A3E" />
        <circle cx="32" cy="18" r="3.6" fill="#2D4A3E" />
        <path
            d="M32 23c-5.2 0-8.4 4-8.4 9v3.2c-2.8 1.2-4.8 3.2-5.9 6.3L16.5 45h31l-1.2-3.5c-1.1-3.1-3.1-5.1-5.9-6.3V32c0-5-3.2-9-8.4-9z"
            fill="#2D4A3E"
        />
        <circle cx="32" cy="27.5" r="1.4" fill="#8A6D1F" />
        <circle cx="32" cy="32" r="1.4" fill="#8A6D1F" />
        <circle cx="32" cy="36.5" r="1.4" fill="#8A6D1F" />
    </svg>
);

export default function Logo({ dark = false }) {
    return (
        <span className="flex items-center gap-3" data-testid="brand-logo">
            <LogoMark className="h-12 w-12 shrink-0" />
            <span className="leading-none">
                <span
                    className={`block whitespace-nowrap font-serif text-base font-semibold tracking-[0.06em] lg:text-lg xl:text-xl ${
                        dark ? "text-cream" : "text-forest"
                    }`}
                >
                    AGASTYA CHIRO
                </span>
                <span
                    className={`mt-1 block whitespace-nowrap text-[8px] font-semibold uppercase tracking-[0.24em] lg:text-[9px] xl:text-[10px] ${
                        dark ? "text-gold" : "text-[#8A6D1F]"
                    }`}
                >
                    and Ancient Marma Therapy
                </span>
            </span>
        </span>
    );
}
